<script lang="ts">
  import * as Icons from './icons';

  export let name = '';
  export let className = '';

  let selectedIcon = (Icons as any)[name];

  const props = {
    className: `${className} fill-current`
  };
</script>

<svelte:component this={selectedIcon} {...props} on:click />
